import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { BsTranslate } from 'react-icons/bs';

const LANGUAGES = [
    { code: 'en', label: 'English' },
    { code: 'ta', label: 'Tamil' },
];

export default function LanguageSwitcher({ onToggle }) {
    const [selectedLang, setSelectedLang] = useState('en');
    const [dropdownOpen, setDropdownOpen] = useState(false);

    useEffect(() => {
        const currentLang = localStorage.getItem('i18nextLng') || 'en';
        setSelectedLang(currentLang);
    }, []);

    const handleChange = (langCode) => {
        setSelectedLang(langCode);
        localStorage.setItem('i18nextLng', langCode);
        if (onToggle) onToggle(langCode);
        setDropdownOpen(false);
    };

    return (
        <motion.div
            className="relative inline-block text-left"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            {/* Selected Language Prefix */}
            <motion.div className="relative justify-center">
                <div className="text-xs absolute -right-2 bg-primeColor/40 p-1.5 rounded-full text-center font-semibold text-black">
                    {selectedLang.toUpperCase()}
                </div>

                {/* Icon and trigger */}
                <button
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="flex items-center justify-center w-14 h-14 rounded-full  focus:outline-none"
                >
                    <BsTranslate className="w-6 h-6 text-white" />
                </button>
            </motion.div>

            {/* Dropdown */}
            {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-32 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg z-50">
                    {LANGUAGES.map((lang) => (
                        <button
                            key={lang.code}
                            onClick={() => handleChange(lang.code)}
                            className={`w-full px-4 py-2 text-sm text-left ${
                                selectedLang === lang.code
                                    ? 'bg-primeColor/20 text-primeColor font-bold'
                                    : 'text-gray-700 hover:bg-primeColor/20'
                            }`}
                        >
                            {lang.label}
                        </button>
                    ))}
                </div>
            )}
        </motion.div>
    );
}
